const styles = theme => ({
    cookieBannerCurtain: {
        position: 'fixed',
        inset: 0,
        zIndex: 999,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        pointerEvents: 'all',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        opacity: 1,
        transition: 'opacity 0.2s ease'
    },
    cookieBanner: {
        zIndex: 999999,
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translateX(-50%) translateY(-50%)',
        padding: '20px',
        width: '475px',
        maxWidth: '95vw',
        height: 'auto',
        backgroundColor: '#f5f5f5',
        fontSize: '12px',
        borderRadius: '15px',
        boxShadow: 'rgba(0, 0, 0, 0.19) 0px 10px 20px, rgba(0, 0, 0, 0.23) 0px 6px 6px',
        '& h1': {
            fontSize: '14px',
        },
    },
    submit: {
        margin: theme.spacing(1, 0, 0),
        color: '#fff',
        flexGrow: 1,
        width: '100%',
        cursor: 'pointer',
        '&.MuiButton-containedSecondary': {
            color: 'rgba(0, 0, 0, 0.87)'
        }
    },
    cookieTypeContainer: {
        backgroundColor: '#dee2e6',
        padding: '10px',
        marginBottom: '5px',
        '& header': {
            display: 'flex',
            '& h1': {
                flexGrow: 3,
            },
        },
    },
    alwaysEnabledIndicator: {
        flexGrow: 1,
        color: 'green',
        textAlign: 'right',
        marginRight: '5px',
    },
    actionsContainer: {
        display: 'flex',
    },
    policyLinks: {
        textAlign: 'center',
    },
})

export default styles